import React, {useEffect} from 'react'
import Navbar from '../component/Navbar';
import Hero from '../component/Hero';
import Fotter from '../component/Fotter';
import project from '../assets/project.jpg';
import beast from '../assets/beast.png';
import photo from '../assets/photo.png';
import thumbnail from '../assets/thumbnail.jpg';
const Projects = () => {
  useEffect(() => {
    document.title = 'AN-TECH - PROJECTS'; // Change the title as desired
    // Make sure to replace 'Your Website Name' with your actual website name
  }, []);

  return (
   <>
   <Navbar/>
   <Hero 
    backgroundImage={project}
    headingText="AN-TECH-PROJECTS"
    paraText="Led to success, showcasing strong teamwork and impressive results."
    buttonText="Discord"
    />
    <section class="text-gray-400 bg-gray-900 body-font">
  <div class="container px-5 py-24 mx-auto">
    <div class="flex flex-wrap -m-4">
      <div class="p-4 md:w-1/3">
        <div class="h-full border-2 border-gray-800 rounded-lg overflow-hidden">
          <img class="lg:h-48 md:h-36 w-full object-cover object-center" src={photo} alt="blog"/>
          <div class="p-6">
            <h1 class="title-font text-lg font-bold text-orange-400 mb-3">IMAGE SEARCH APP</h1>
            <p class="leading-relaxed mb-3">It is a image search app made byy CODEWITHNABIL. he is our web devloper in our agency he can make asthetic website for you.</p>
            <div class="flex items-center flex-wrap ">
            <div class="buttons">
  <button onClick={() => window.location.href = 'https://photobazzar.netlify.app/'} class="bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-5 rounded cursor-pointer">VIEW FULL PROJECT</button>
</div>
            </div>
          </div>
        </div>
      </div>
      <div class="p-4 md:w-1/3">
        <div class="h-full border-2 border-gray-800 rounded-lg overflow-hidden">
          <img class="lg:h-48 md:h-36 w-full object-cover object-center" src={beast} alt="blog"/>
          <div class="p-6">
           
            <h1 class="title-font text-lg font-bold text-orange-400 mb-3">PORTFOLIO WEBSITE FOR GAMER.</h1>
            <p class="leading-relaxed mb-3">It is a portfolio website fr a gamer made by again CODEWITHNABIL after seeing this project that we can a asthetic website for you .</p>
            <div class="flex items-center flex-wrap">
             
              <div class="buttons">
  <button onClick={() => window.location.href = 'https://beast-ak.netlify.app/'} class="bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-5 rounded cursor-pointer">VIEW FULL PROJECT</button>
</div>
            </div>
          </div>
        </div>
      </div>
      <div class="p-4 md:w-1/3">
        <div class="h-full border-2 border-gray-800 rounded-lg overflow-hidden">
          <img class="lg:h-48 md:h-36 w-full object-cover object-center" src={thumbnail}alt="blog"/>
          <div class="p-6">
           
            <h1 class="title-font text-lg font-bold text-orange-400 mb-3">GRAPHICS DESIGNING PRODUCTS.</h1>
            <p class="leading-relaxed mb-3">It is a pdf of logo banner poster thumbnail for your showcase this work is just an example we have maked even more better than this.</p>
            <div class="flex items-center flex-wrap ">
              
              <div class="buttons">
  <button onClick={() => window.location.href = 'https://drive.google.com/file/d/1cB8Helff6FndlVkaCwYa1cKDW07vGBpI/view?usp=sharing'} class="bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-5 rounded cursor-pointer">VIEW FULL PROJECT</button>
</div>
      
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

   <Fotter/>
   </>
  )
}

export default Projects


